import React from 'react';
import TopBar from '../Menu/TopBar';
import '../CSS/styles.css';

export default function TomEnglishAIResume() {

  return (
      <div style={{opacity: 1.0 }}>
          <TopBar/>
          <header>
              <h1>Pre-2025 Resume for Tom English</h1>
              <p style={{color: 'white', padding: '0px'}}><b>Detailed Resume - Pre-TEAI Projects</b></p>
              <p style={{color: 'white', padding: '0px'}}><b>14 live certification links | 30+ trainings | Full job descriptions</b></p>
          </header>            
          <main>
            <center>
            <table style={{ width:'70%' }}>
              <colgroup>
                <col style={{ width: '27%' }} />
                <col style={{ width: '46%', alignContent:'center' }} />
                <col style={{ width: '27%' }} />
                </colgroup>
              <thead>
                <tr>
                  <td>
                    <p><a target="blank" href="https://www.linkedin.com/in/TomEnglish23">linkedin.com/in/TomEnglish23</a></p>
                    <p><a target="blank" href="https://www.facebook.com/people/Tom-English-AI/100067604027953/">Facebook Tom English AI</a></p>
                  </td>
                  <td>
                    <center><p style={{marginBottom:'15px'}}><a target="blank" href="https://tomenglishai.com/TomEnglishAI/">TomEnglishAI.com</a></p></center>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <p>January, 2025</p>
                    <p>JobSearch@TomEnglishAI.com</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                  <center><p style={{marginBottom:'15px'}}><b>Microsoft &amp; Azure Certified</b></p></center>
                  <center><p>25-year Senior Microsoft Developer - AI Tools &amp; Machine Learning - Microsoft Azure</p></center>
                    <center><p>.NET, C#, SQL, Azure, AI, ML, Python, Node, React, PineScript</p></center>
                  </td>
                </tr>
                
              </thead>
              <tbody />
            </table>
            </center>

            <p style={{fontSize:'20px', margin:'30px 0px 10px 0px'}}><b>CERTIFICATIONS</b></p>
            <table>
              <colgroup><col style={{ width: '22%' }} /><col /></colgroup>
              <tbody>
                <tr>
                  <td style={{ fontSize:'16px' }}><b>Microsoft:</b></td>
                  <td style={{ fontSize:'16px' }}>Microsoft MCPD  Microsoft Certified Professional Developer</td>
                </tr>                
                <tr>
                  <td></td>
                  <td style={{ fontSize:'16px' }}>Microsoft MCTS  Microsoft Certified Technology Specialist</td>
                </tr>                
                <tr>
                  <td></td>
                  <td style={{ fontSize:'16px' }}><a href="https://learn.microsoft.com/en-us/users/thomasenglish-9156/transcript/7o4l4f045yqlqzn">Microsoft AZ-900 Azure Fundamentals</a></td>
                </tr>
              </tbody>
            </table>

            <p style={{ height:'1px'}}></p>
            <table style={{ width:'85%' }}>
              <colgroup>
                <col style={{ width: '50%' }} />
                <col />
                </colgroup>
              <tbody>
                <tr>
                  <td>
                    <table style={{ width:'100%'}}>
                      <colgroup>
                        <col style={{ width: '26%' }} />
                        <col />
                        </colgroup>
                      <tbody>
                        <tr>
                          <td style={{ fontSize:'16px' }}><b>.NET/C#/SQL:</b></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="http://ude.my/UC-ac8454f0-5fcf-442c-bda9-676bdde1fa81">Entity Framework Core .NET Core 5</a></td>
                        </tr>                
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="http://ude.my/UC-9dd20893-7898-40e8-b3e3-30e996eba933">Dependency Injection in .NET 5 .NET Core</a></td>
                        </tr>                
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-Z514MH4R">Design Patterns in C# and .NET</a></td>
                        </tr>                
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-J5ITZLVF">Parallel Programming with C# and .NET</a></td>
                        </tr>                
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="https://www.hackerrank.com/certificates/07c86ae26e89">C# Basic</a></td>
                        </tr>                
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="https://www.hackerrank.com/certificates/947539b63d04">SQL Basic</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table  style={{ width:'100%'}}>
                      <colgroup>
                        <col style={{ width: '18%' }} />
                        <col />
                        </colgroup>
                      <tbody>
                        <tr>
                          <td style={{ fontSize:'16px' }}><b>Angular:</b></td>
                          <td style={{ fontSize:'16px' }}><a target=":blank" href="https://www.hackerrank.com/certificates/314ade6928dc">JavaScript Basic</a></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-OQIHO21Y">Angular 7</a></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-HIMBNBL3">Angular 7 Quick Guide</a></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-W8UOKVXE">Angular 7 Quick Start Guide</a></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-PTUKZTND">Angular 7 Build Awesome Web Apps</a></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-32c92b8e-c3aa-479e-8a32-8aa3ac28a069">Angular 8 building a Progressive Web App (PWA)</a></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-ebea035b-dec4-4a26-8200-19aed682bbd8">Angular 12 Web apps: .NET Core WebAPI, Mongo DB</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            <p style={{fontSize:'20px', margin:'20px 0px 2px 0px'}}><b>TRAININGS</b></p>
           
            <table style={{ width:'90%' }}>
              <colgroup><col style={{ width: '3%' }} /><col style={{ width: '35%' }} /></colgroup>
              <tbody>
                <tr><td colSpan="3"></td></tr>
                <tr><td colSpan="3" style={{ fontSize:'16px' }}><b>Docker, Microservices, Azure</b></td></tr>
                <tr><td></td><td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-89ae4e75-125e-47b6-b8c5-7a1b7f71ecce">Docker with MS .NET Core</a></td>
                    <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-T58MPCXQ">Azure Step by Step</a></td></tr>
                <tr><td></td><td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-57584ba1-f773-492a-88aa-3f39963f0893">Microservices Architecture</a></td>
                    <td style={{ fontSize:'16px' }}><a target="blank" href="ude.my/UC-d48a7985-5d1a-48a0-8183-79931e0f4cfb">Azure Devops .NET 5 API Build/Deploy/Test</a></td></tr>
              </tbody>
            </table>
           
            <table style={{ width:'90%' }}>
              <colgroup><col style={{ width: '3%' }} /><col style={{ width: '34%' }} /><col style={{ width: '26%' }} /><col /></colgroup>
                <tbody>
                  <tr><td colSpan="4"></td></tr>
                  <tr><td colSpan="4"></td></tr>

                  <tr><td colSpan="3" style={{ fontSize:'16px' }}><b>Azure AI, Machine Learning &amp; Resources</b></td>
                      <td style={{ fontSize:'16px' }}>All trainings on <a target="blank" href="learn.microsoft.com">learn.microsoft.com</a></td></tr>
                  <tr><td></td><td colSpan="3" style={{ fontSize:'16px' }}>Introduction to Azure Machine Learning (<a target="blank" href="kaggle.com/learn">kaggle.com/learn</a>)</td></tr>
                  <tr><td></td><td colSpan="3" style={{ fontSize:'16px' }}>Train Machine Learning Model, predictive maintenance using ML.NET Model Builder</td></tr>
                  <tr><td></td><td colSpan="3" style={{ fontSize:'16px' }}>Use Automated Machine Learning in Azure Machine Learning</td></tr>
                </tbody>
            </table>

            <table style={{ width:'90%' }}>
              <colgroup><col style={{ width: '3%' }} /><col style={{ width: '39%' }} /><col style={{ width: '27%' }} /><col /></colgroup>
              <tbody>
                <tr><td></td>
                  <td style={{ fontSize:'16px' }}>Azure Data Fundamentals:</td>
                  <td style={{ fontSize:'16px' }}>-Explore core data concepts</td>
                  <td style={{ fontSize:'16px' }}>-Explore data roles and services</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Discover AI for leaders in sustainability</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Define an MS AI strategy to create business value in sustainability</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>&nbsp; and Create Machine Learning Models:</td>
                    <td style={{ fontSize:'16px' }}>-Explore/Analyze data w/Python</td>
                    <td style={{ fontSize:'16px' }}>-Train/Evaluate regression models</td></tr>
                <tr><td colSpan="2"></td>
                    <td style={{ fontSize:'16px' }}>-Scale AI in your organization</td>
                    <td style={{ fontSize:'16px' }}>-Train/Evaluate classification models</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Machine Learning: Optimize Model training:</td>
                    <td style={{ fontSize:'16px' }}>-Run pipelines in Azure ML</td>
                    <td></td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Machine Learning: Notebooks for experiments:</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Track Model training in Jupyter notebooks with MLflow</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Transform your business with Microsoft AI</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Leverage AI tools and resources for your business</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Create business value from AI</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Embrace responsible AI principles and practices</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Scale AI in your organization</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Get started with Azure AI Services:</td>
                    <td style={{ fontSize:'16px' }}>-Secure Azure AI services</td>
                    <td style={{ fontSize:'16px' }}>-Prepare to develop Azure AI solutions</td></tr>
                <tr><td colSpan="2"></td>
                    <td style={{ fontSize:'16px' }}>-Monitor Azure AI services</td>
                    <td style={{ fontSize:'16px' }}>-Create/Consume Azure AI services</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Azure AI Services: Develop NLP solutions:</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Build a conversational language understanding model</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Manage resources in Azure:</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Control Azure Services with the CLI</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Align requirements with cloud types and service models in Azure</td></tr>
                <tr><td colSpan="4"></td></tr>

                <tr><td colSpan="3" style={{ fontSize:'16px' }}><b>Python</b></td>
                    <td colSpan="1" style={{ fontSize:'16px' }}>All trainings on <a target="blank" href="learn.microsoft.com">learn.microsoft.com</a></td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Build real world applications with Python:</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Introduction to Python</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Introduction to object-oriented programming with Python</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Build an AI web app using Python and Flask</td></tr>
                <tr><td colSpan="2"></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Get started with testing in Python</td></tr>
                <tr><td></td>
                    <td style={{ fontSize:'16px' }}>Python: Solve mysteries and find answers:</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>-Install and configure VS Code for Python development</td></tr>
              </tbody>
            </table>

            <p style={{fontSize:'20px', margin:'30px 0px 10px 0px'}}><b>DEGREE</b></p>
            <p>B.S. in Electrical Computer Engineering at Southeastern Massachusetts University</p>

            <p style={{fontSize:'20px', margin:'30px 0px 10px 0px'}}><b>PROFESSIONAL EXPERIENCE</b></p>
            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup>
              <tbody>
                <tr>
                  <td style={{ fontSize:'16px'}}><b>Tom English AI</b></td>
                  <td style={{ fontSize:'16px'}}><b>Developer: ML / Stock Market Tools / AI Tools</b></td>
                  <td style={{ fontSize:'16px'}}><b>05/24 - Present</b></td>
                </tr>
              </tbody>
            </table>

            <p>Developing a stock market AI/ML platform</p>
            <p style={{marginLeft:"20px"}}> API data input. Algorithm management, sequencing &amp; training vs archived rankings. </p>
            <p style={{marginLeft:"20px"}}> UI: React &amp; Console apps  Algorithms: Pinescript, Algorithm Sequencer Pipeline, ML concepts</p>
            <p style={{marginLeft:"20px"}}> Comms: React-node.js WebSockets  Data storage:  MySQL via Python &amp; node.js</p>
            <p style={{marginLeft:"20px"}}>  React-Python WebSockets  Data APIs: TradingView &amp; FinnHub data collection via Python</p>
            <p style={{marginLeft:"20px"}}>Developing TradingView Pinescripts for stock analysis</p>
            <p style={{marginLeft:"20px"}}>Analyzed stock on various platforms:  TradingView, RobinHood, Schwab ThinkOrSwim, TopTradeTitan</p>
            <p style={{margin:'15px 0px 4px 40px'}}>Python, PineScript, React, Node.js, C#, MySQL Workbench<br/ >
            VS Code, VS 2022 for ML development, Jupyter</p>

            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody><tr>
                  <td style={{ fontSize:'16px'}}><b>SMB Capital</b></td>
                  <td style={{ fontSize:'16px'}}><b>Internship: Stock Market</b></td>
                  <td style={{ fontSize:'16px'}}><b>04/24 - 05/24</b></td></tr></tbody></table>

            <p>Attended Stock Market Investing training courses with stock options trading tools.</p>

            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody><tr>
                  <td style={{ fontSize:'16px'}}><b>Tom English AI</b></td>
                  <td style={{ fontSize:'16px'}}><b>Developer: Azure / Machine Learning / Python / .NET</b></td>
                  <td style={{ fontSize:'16px'}}><b>11/23 - 04/24</b></td></tr></tbody></table>
            
            <p>Developed Machine Learning environments to input &amp; analyze Stock Market data &amp; indicators. </p>
            <p>Developed Azure ServiceBus messaging functions.</p>
            <p>Developed .NET Core Web App Razor Pages for port to Azure.</p>
            <p>Ported existing .NET Core Web API REST APIs to API Management Services.</p>
            <p style={{margin:'15px 0px 4px 20px'}}>Docker, Powershell, GitHub Copilot, GitHub Actions, Git Bash &nbsp;&nbsp;&nbsp;Groups:  Kaggle.com, Microsoft Reactor</p>
            <p style={{marginLeft:"20px"}}>Azure: Portal, CLI, App services, API Management services, Data Studio, Resource Graph, SQL Server</p>
            <p style={{marginLeft:"20px"}}>Machine Learning: Anaconda Navigator, Jupyter notebooks and python: [scikit-learn, pandas, NumPy, Matplotlib]</p>
            <p style={{marginLeft:"20px"}}>MLflow, Flask, ML.NET, ServiceBus, Messaging, Functions, TradingView PineScript </p>
            
            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody><tr>
                  <td style={{ fontSize:'16px'}}><b>Wells Fargo, Compliance Risk</b></td>
                  <td style={{ fontSize:'16px'}}><b>Sr .NET Developer</b></td>
                  <td style={{ fontSize:'16px'}}><b>09/21 - 09/23</b></td></tr></tbody></table>
                        
            <p>Hired to migrate two intranet compliance and risk banking applications:</p>
            <p style={{marginLeft:"20px"}}> WebAPIs: .NET to .NET Core, .NET DI &amp; EF Core </p>
            <p style={{marginLeft:"20px"}}> Logging: log4net to  Serilog</p>
            <p style={{marginLeft:"20px"}}> CICD: TFS to Google PCF &amp; Jenkins</p>
            <p style={{marginLeft:"20px"}}>Added .NET extensions for  DI , Swagger &amp; in-memory database testing</p>
            <p style={{marginLeft:"20px"}}>Migrated unit testing to use in-memory databases</p>
            <p style={{margin:'15px 0px 4px 40px'}}>WebAPIs: VS 2022, .NET 8.0, .NET Core 3.1, EF Core, DI, C# 10.0, Serilog, Aegis Authenticator, Swagger</p>
            <p style={{marginLeft:"40px"}}>Angular 14, Gradle/Maven, Selenium</p>
            <p style={{marginLeft:"40px"}}>SQL Server stored procedures</p>
            <p style={{marginLeft:"40px"}}>Cloud: PCF Pivotal Cloud Foundry, SonarQube, BlackDuck, CheckMarx, TruffleHog, AppDynamics </p>
            <p style={{marginLeft:"40px"}}>GitHub, Jira, Confluence, Jenkins, Artifactory/Jfrog</p>
            
            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody>
              <tr><td style={{ fontSize:'16px'}}><b>Bank of America / Merrill Lynch</b></td><td style={{ fontSize:'16px'}}><b>Sr .NET Developer / Team Lead</b></td><td style={{ fontSize:'16px'}}><b>10/17 - 09/21</b></td></tr></tbody></table>
            
            <p><b>Desktop: Merrill Lynch financial agent desktop</b></p>
            <p style={{marginLeft:"20px"}}>Hired to lead &amp; develop enhancements to large internal applications:</p>
            <p style={{marginLeft:"40px"}}>Enhancements to the client and server-side application, services, databases with session transactions similar to FIX.</p>
            <p style={{marginLeft:"40px"}}>Created a batch job for peer service updates from SQL queries.</p>
            <p style={{marginLeft:"40px"}}>Performed POC client and user-side logging enhancements.</p>
            <p style={{marginLeft:"40px"}}>Performed POC analysis to unify financial team hierarchy visibility and access to services and data.</p>
            <p><b>Website: Bank of America financial website</b></p>
            <p style={{marginLeft:"20px"}}>Hired to port an internal business site: MVC 2 to MVC 5, Telerik to Kendo UI, UI grids, JavaScript, Ajax.</p>
            <p style={{margin:'15px 0px 4px 60px'}}>MVC 5.2, .NET 5.0, .NET Core 3.1, Entity Framework Core, .NET 5 DI, C# 9.0, TDD </p>
            <p style={{marginLeft:"60px"}}>WebAPIs, Windows Services, Batch jobs, ActiveDirectory, Authentication, SQL Server, DB2, Grafana </p>
            <p style={{marginLeft:"60px"}}>Logging: log4net, Splunk API, dashboards and alerts </p>
            <p style={{marginLeft:"60px"}}>Client: Angular 12, TypeScript 3.5, Node.js, npm, CSS 3, Chronium, Electron 9.4</p>
            <p style={{marginLeft:"60px"}}>Session management, Telecom, Genesys Content Management System, Audio recording</p>

            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody>
              <tr><td style={{ fontSize:'16px'}}><b>DotNet Technologies</b></td><td style={{ fontSize:'16px'}}><b>Sr .NET Developer / Architect / Team Lead</b></td><td style={{ fontSize:'16px'}}><b>03/11 – 10/17</b></td></tr></tbody></table>
            
            <p style={{fontSize:'16px', margin:'5px 0px 4px 20px'}}><b>Clean Harbors:</b></p>
              <p style={{marginLeft:"20px"}}>Architected an e-Billing interface to allow outsource of each transport layer.</p>

            <p style={{fontSize:'16px', margin:'15px 0px 4px 20px'}}><b>Delta Dental:</b></p>
              <p style={{marginLeft:"20px"}}>Architected an SSRS enrollment-reporting system on Oracle and SQL Server.</p>
            
            <p style={{fontSize:'16px', margin:'15px 0px 4px 20px'}}><b>Boston Hospitals:</b></p>
              <p style={{marginLeft:"20px"}}>Sole developer for 30+ websites for 5 Boston hospitals.</p>
            
            <p style={{fontSize:'16px', margin:'15px 0px 4px 20px'}}><b>Smaller efforts:</b></p> 
            <p style={{marginLeft:"20px"}}>Developed a BDD test suite and an HL7 import application.</p>
            <p style={{marginLeft:"20px"}}> Developed POC applications: Web, MVC WebAPIs, console</p>
            <p style={{marginLeft:"20px"}}> Researched cloud platforms for future endeavors</p>
            <p style={{margin:'15px 0px 4px 40px'}}>MVC 2.0, ASP.NET Core 2.0, C#, .NET, Web Services, ASP.NET, VB.NET, VSTest, MSTest</p>
            <p style={{marginLeft:"40px"}}>Angular 2.0, AngularJS, KnockoutJS, Telerik, XML, XSLT </p>
            <p style={{marginLeft:"40px"}}>SQL Server, SSIS, SSRS, Oracle PL SQL, HL7, Excel, PDF, SMTP, BDD</p>
            
            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody>
              <tr><td style={{ fontSize:'16px'}}><b>Florida Healthcare Plans</b></td><td style={{ fontSize:'16px'}}><b>Sr .NET / Mobile Developer / Tech Lead</b></td><td style={{ fontSize:'16px'}}><b>01/09 - 03/11</b></td></tr></tbody></table>
            
            <p>Developed distributed software for HIPPA, ANSI ASC X12N 4010/5010 EDI healthcare transaction protocols: </p>
            <p style={{margin:'15px 0px 4px 20px'}}> 270/271, 276/277, 278, 834, 835, 837, Payments, Remittance, Providers, Claims, Members, Venders</p>
            <p style={{marginLeft:"20px"}}>C#, .NET, VB.NET, SQL, WCF, Windows apps</p>
            
            <table style={{ width:'90%', margin:'15px 0px 4px 0px' }}><colgroup><col style={{ width: '30%' }} /><col style={{ width: '50%' }} /><col /></colgroup><tbody>
              <tr><td style={{ fontSize:'16px'}}><b>Genitiva Health Services</b></td><td style={{ fontSize:'16px'}}><b>Sr .NET / Mobile Developer</b></td><td style={{ fontSize:'16px'}}><b>12/06 - 01/09</b></td></tr></tbody></table>
            
            <p>Agile team developed Windows Mobile software for a Microsoft Compact Mobile visiting nurse PDA application</p>
            <p>Tools: Build, Deploy</p>
            <p> PL/SQL:  Queries control visit workflow stages</p>
            <p> ETL: Mobile data replication, ETL</p>
            <p>Database:  Partnered with Microsoft CE Team to investigate leading-edge Microsoft mobile large database issues </p>
            <p>POC: Developed an SSIS app as an alternative to the .NET ETL application</p>
            <p>POC: Developed an MVVM application</p>
            <p>POC: Architected a distributed data-collection system to collect user data from mobile devices:</p>
            <p> SMS: Initiates data collection for display and storage </p>
            <p> Data: GPS coordinates, database, error snapshots, registry, device-management, logs</p>
            <p> Components: SMS, mobile applications, web service, Windows service, SQL, email </p>
            <p style={{margin:'15px 0px 4px 20px'}}>C#, Web Services, Windows Services, Web applications, MVVM, MSBuild </p>
            <p style={{marginLeft:"20px"}}>Windows CE SQL Server (mobile), SQL Server, SSIS, SSMS, ETL </p>
            <p style={{marginLeft:"20px"}}>Oracle PL SQL</p>
            <p style={{marginLeft:"20px"}}>Mobile apps, Windows Mobile, Windows Mobile registry, mobile SMS, mobile GPS, mobile SMTP</p>
            
            <p style={{fontSize:'20px', margin:'40px 0px 10px 0px'}}><b>TECHNICAL SKILLS</b></p>

            <table style={{ width:'90%' }}>
              <colgroup><col style={{ width: '140px' }} /><col style={{ width: '95px' }} /><col /></colgroup>
              <tbody>
                <tr><td style={{ fontSize:'16px' }}><b>AI</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>AI, Machine Learning, Jupyter Notebooks, Data collection &amp; analysis</td></tr>

                <tr><td style={{ fontSize:'16px' }}><b>Cloud</b></td>
                    <td style={{ fontSize:'16px' }}>Azure:</td>
                    <td style={{ fontSize:'16px' }}>AZ-900, Functions, WebApps, Services, API Management</td></tr>
                <tr><td colSpan="2"></td>
                    <td style={{ fontSize:'16px' }}>GitHub Copilot,  Python, Machine Learning, ML.NET, Flask</td></tr>
                <tr><td colSpan="2"></td>
                    <td style={{ fontSize:'16px' }}>GitHub Actions,  PowerShell, Bash, Azure CLI, Docker</td></tr>
                <tr><td></td><td style={{ fontSize:'16px' }}>Google:</td>
                <td colSpan="2" style={{ fontSize:'16px' }}>PCF deploy, SonarQube, BlackDuck, CheckMarx, TruffleHog, AppDynamics</td></tr>
                <tr><td></td><td style={{ fontSize:'16px' }}>Research:</td>
                <td colSpan="2" style={{ fontSize:'16px' }}>1 month project: AWS, BPM, EAI, ESB, CEP, TIBCO, Tableau, Docker, Microservices</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Full Stack</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>VS 2022, VS Code, .NET 8.0, EF Core, DI, C# 10.0, .NET Core 3.1, Serilog, Aegis, Swagger</td></tr>
                <tr><td></td><td colSpan="2" style={{ fontSize:'16px' }}>MVC 5, ASP.NET 4.7, WebAPI 2, WCF, Windows Services, EF 6</td></tr>
                <tr><td></td><td colSpan="2" style={{ fontSize:'16px' }}>Multi-threading, Windows Mobile, TDD, VSTest, MSTest, NUnit </td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Client-Side</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>React, Angular 14, Typescript 3.5, Node.js, npm, Electron 9.4, Chromium, KnockOut JS</td></tr>
                <tr><td></td><td colSpan="2" style={{ fontSize:'16px' }}>Razor, JavaScript, jQuery, BootStrap, HTML 5, CSS 3, AJAX, Webpack, UI-grid</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Database</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>MySQL, SQL Server 2014/2008, Stored procedures, ETL, SSIS, SSRS, Oracle 11.2, PL/SQL, mongoDB</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>3<sup>rd</sup> Party</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>Telerik, Kendo UI, PDF, Excel, SMTP, DevExpress, ASR, Voicemail</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Reporting</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>SSRS, Splunk queries, alerts and dashboards</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Financial</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>Payments, remittance, card/consumer oversight, reporting, audit, remediation; Financial agent; telecom</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Telephony</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>Session managers, Resource managers, SS7/ISDN Q.931, T1/E1, OC3/STM, PPP callback, ethernet</td></tr>
                    <tr><td></td><td colSpan="2" style={{ fontSize:'16px' }}> IP, VLANs, bridges, DTMF, FAX, MWI, DS1, ISDN/analog modems, LCP/CBCP/SNMP/RIP/OSPF </td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Device Drivers</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>SunOS, UnixWare, Solaris, Compaq Tru64 UNIX, Windows NT, VMEbus, SBUS, ATbus, SCSI  </td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Real-Time</b></td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>VRTX, ARTX</td></tr>
                <tr><td style={{ fontSize:'16px' }}><b>Healthcare</b></td>
                    <td style={{ fontSize:'16px' }}>Protocols:</td>
                    <td colSpan="2" style={{ fontSize:'16px' }}>EDI, X12, HL7 - Provider, Member, Claims, Enrollment, Inquiry, Payment, Remittance</td></tr>
                <tr><td></td><td style={{ fontSize:'16px' }}>ASP.NET:</td>
                <td colSpan style={{ fontSize:'16px' }}>Hospital and lab applications</td></tr>
                <tr><td></td><td style={{ fontSize:'16px' }}>Mobile:</td>
                <td colSpan="2" style={{ fontSize:'16px' }}>Visiting Nurse application</td></tr>
                {/* <tr><td>Agile / Deploy</td>
                    <td colSpan="2">Jira, Confluence, Jenkins, Artifactory/JFrog, GitHub, Rally, Horizon, BitBucket, TFS, SourceSafe, 
                        PCF, AZ-900, SonarQube, BlackDuck, CheckMarx, TruffleHog, AppDynamics, SourceGear Vault</td></tr> */}
              </tbody>
            </table>

            <p style={{fontSize:'20px', margin:'30px 0px 10px 0px'}}><b>PUBLICATIONS</b></p>
            <p><a target="blank" 
            href="slideshare.net/slideshow/embed_code/key/jQdsdj06s5y5lE">Shared MVC ControllerActionFilter &amp; ControllerBase</a> </p>
            <p><a target="blank" 
            href="linkedin.com/pulse/microsoft-core-20-installation-tom-english-mcpd">Microsoft Core 2.0 Installation</a> </p>
            <p><a target="blank" 
            href="linkedin.com/pulse/microsoft-visual-studio-code-installation-tom-english-mcpd"> Microsoft Visual Studio Code Installation</a> </p>

            <p style={{fontSize:'20px', margin:'30px 0px 10px 0px'}}><b>DESIGN PATTERNS / INNOVATIONS</b></p>
            <p>
              <b>{/* <div style={{ color: 'maroon', display:'inline' }}> */}Deciphered Google algorithms{/* </div> */}</b>
              : Created proprietary SEO thesaurus-driven, deep-URL naming, keyword placement technique.</p>
            <p>
              <b>{/* <div style={{ color: 'maroon', display:'inline' }}> */}Proprietary Code Generator{/* </div> */}</b>
              : &nbsp;&nbsp;for rapid development generating n-layer code from SQL metadata.</p>
          </main>
        </div>
    )
}
            